import React, { useEffect, useState } from 'react';
import { Button, Modal} from 'react-bootstrap';
import { useParams } from "react-router-dom";
import { useAuth } from '../../../../Auth';
import { useTranslate } from 'react-polyglot';
import PageTable from '../../../Shared/PageTable/PageTable';
import CreateMultiplePersonsModal from '../../../Shared/Modals/Create/CreateMultiplePersonsModal';
import CreateGuestAndCustomerModal from '../../../Shared/Modals/Create/CreateGuestAndCustomerModal';
import EmailSender from '../../../Shared/EmailSender/EmailSender';
import { useAxios } from '../../../../AxiosHandler';
import SMSSender from '../../../Shared/SMSSender/SMSSender';
import EditPersonModal from '../../../Shared/Modals/Edit/EditPersonModal';

import moment from 'moment';

function EventGuests(props) {
    let { id } = useParams();
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const localStorageUser = localStorage.getItem("user");
    let settings;
    if (localStorageUser != null) {
        settings = JSON.parse(localStorageUser)["settings"];
    }

    function dateToText(date) {
        return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    }

    const [showParticipantsModal, setShowParticipantsModal] = useState(false);
    const [participantsEventId, setParticipantsEventId] = useState("");
    const [booking, setBooking] = useState({});

    const [allGuests, setAllGuests] = useState<Array<any>>([]);
    const [bookings, setBookings] = useState<Array<any>>([]);

    const [updateTable, setUpdateTable] = useState(0);

    const [showCreateMultiplePersonsModal, setShowCreateMultiplePersonsModal] = useState(false);
    const [showCreateGuestAndCustomerModal, setShowCreateGuestAndCustomerModal] = useState(false);
    const [showConfirmationAllModal, setShowConfirmationAllModal] = useState(false);
    const [showConfirmationAllSmsModal, setShowConfirmationAllSmsModal] = useState(false);

    const [showEditGuestModal, setShowEditGuestModal] = useState(false);
    const [editGuestId, setEditGuestId] = useState("");
    const [editGuestOrg, setEditGuestOrg] = useState("");

    const handleShowCreateGuestAndCustomerModal = () => { setShowCreateGuestAndCustomerModal(true); };

    const handleShowParticipantsModal = (dataLine) => {
         setShowParticipantsModal(true)
         setParticipantsEventId(dataLine._id);
         setBooking(dataLine);
    }
    const handleCloseParticipantsModal = () => setShowParticipantsModal(false);

    const handleMultipleCustomersAndGuestsAdded = (guests) =>{
        setShowCreateMultiplePersonsModal(false);
        
        let tempBooking = booking;

        if (tempBooking["guests"] == undefined) tempBooking["guests"] = [];

        guests.forEach(guest => {
            if (!tempBooking["guests"].map(g => g._id).includes(guest._id)) {
                tempBooking["guests"].push({_id: guest._id });
            }
        });

        if (props.onGuestAdd != undefined) {
            props.onGuestAdd();
        }
        
        setUpdateTable(updateTable + 1);
    }

    const handleGuestAdded = (guest) =>{
        setShowCreateGuestAndCustomerModal(false);
        let tempBooking = booking;

        if (tempBooking["guests"] == undefined) tempBooking["guests"] = [];

        if (!tempBooking["guests"].map(g => g._id).includes(guest._id)) {
            tempBooking["guests"].push({_id: guest._id });
        }

        if (props.onGuestAdd != undefined) {
            props.onGuestAdd(JSON.parse(JSON.stringify(tempBooking)));
        }

        setUpdateTable(updateTable + 1);
    }

    const handleGuestDeleted = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        let tempBooking = booking;

        let tempResources = props.allResources;
        tempResources = tempResources.map((r: any) => {
            let tempResourceBooking = r.bookings.find(b => b.bookingId == tempBooking["_id"]);

            if (tempResourceBooking != undefined) { 
                tempResourceBooking.people = tempResourceBooking.people.filter(g => g != dataLine._id);

                if (tempResourceBooking.people.length == 0) {
                    tempResourceBooking.bookingId = "";
                }

                r.bookings = [...r.bookings.filter(b => b.uuid != tempResourceBooking.uuid), tempResourceBooking];
            }

            return r;
        });

        tempBooking["guests"] = tempBooking["guests"].filter( item => {
            return item._id != dataLine._id;
        });

        if (props.onGuestDelete != undefined) {
            props.onGuestDelete(JSON.parse(JSON.stringify(tempBooking)), dataLine._id);
        }
        if(props.onResourcesChange != undefined){
            props.onResourcesChange(JSON.parse(JSON.stringify(tempResources)));
        }
        
        setUpdateTable(updateTable + 1);
    };

    function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/persons/byBooking/byEvent/" + id,
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
            axios.single({
                method: "get",
                url: "/api/bookings/byEventId/" + id,
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
        ])
        .then(axios.spread((...res) => {
            setAllGuests(res[0]["data"]);
            setBookings(res[1]["data"]);
        }))
        .catch(err => console.log(err));
    }

    function generateConfirmationMessageSms(person) {
        let message = "";

        let SmsMessage = settings?.confirmationTextSms ?? "";

        if (SmsMessage == undefined || SmsMessage == "") {
            message += t("booking.guests.confirmationmessage.line1") + "\n\n";
            message += t("booking.guests.confirmationmessage.line2") + "\n";
        } else {
            message = SmsMessage;
        }

        let personBookings: any = [];
        for (const booking of bookings) {
            let bookingResources = props.allResources.filter(r => booking.resources.map(b => b.resource).includes(r._id));

            for (const bookingResource of bookingResources) {
                let resourceBookings = bookingResource.bookings.filter(b => b.people.includes(person._id.toString()) && b.eventId.includes(id));

                for (const resourceBooking of resourceBookings) {
                    if (!personBookings.map(b => b.resource._id).includes(bookingResource._id)) {
                        personBookings.push({
                            ...resourceBooking,
                            resource: bookingResource
                        });
                    }
                }
            }
        }
        
        let bookingsMessage = "";
        for (const personBooking of personBookings) {
            let isSpecified = false;
            for (let personBookingtime of personBooking.bookingtimes) {
                if (personBookingtime.people != undefined && (personBookingtime.people?.includes(person._id) ?? false)) {
                    isSpecified = true;
                }
            }

            let personBookingtimes = personBooking.bookingtimes.filter(bt => bt != undefined && bt.eventId == id && (moment(bt.start) > moment().add(-1, "day")));
            
            if (isSpecified) {
                personBookingtimes = personBookingtimes.filter(bt => bt.people?.includes(person._id) ?? false);
            }

            if (personBookingtimes.length > 0) {
                bookingsMessage += personBooking.resource.name + "\n";
            }

            for (const bookingtime of personBookingtimes) {
                bookingsMessage += dateToText(new Date(bookingtime.start)) + " " + t("booking.guests.confirmationmessage.to") + " " + dateToText(new Date(bookingtime.end)) + "\n";
            }

            if (personBookingtimes.length > 0) {
                bookingsMessage += "\n";
            }
        }
        
        if (SmsMessage == undefined || SmsMessage == "") {
            message += bookingsMessage;
        } else {
            message = message.replaceAll("[bookings]", bookingsMessage.slice(0, -2));
            message = message.replaceAll("[guest-firstname]", person.firstname);
            message = message.replaceAll("[guest-lastname]", person.lastname);
            message = message.replaceAll("[guest-organisation]", person.organization);
        }
        
        if (SmsMessage == undefined || SmsMessage == "") {
            message += t("booking.guests.confirmationmessage.line3") + "\n";
            message += t("booking.guests.confirmationmessage.line4");
        }

        return message;
    }

    function generateConfirmationMessageEmail(person) {
        let message = "";

        let personBookings: any = [];
        for (const booking of bookings) {
            let bookingResources = props.allResources.filter(r => booking.resources.map(b => b.resource).includes(r._id));

            for (const bookingResource of bookingResources) {
                let resourceBookings = bookingResource.bookings.filter(b => b.people.includes(person._id.toString()) && b.eventId.includes(id));

                for (const resourceBooking of resourceBookings) {
                    if (!personBookings.map(b => b.resource._id).includes(bookingResource._id)) {
                        personBookings.push({
                            ...resourceBooking,
                            resource: bookingResource
                        });
                    }
                }
            }
        }
        
        let bookingsMessage = "";
        for (const personBooking of personBookings) {

            let isSpecified = false;
            for (let personBookingtime of personBooking.bookingtimes) {
                if (personBookingtime.people != undefined && personBookingtime.people.includes(person._id)) {
                    isSpecified = true;
                }
            }

            let personBookingtimes = personBooking.bookingtimes.filter(bt => bt != undefined && bt.eventId == id && (moment(bt.start) > moment().add(-1, "day")));
            
            if (isSpecified) {
                personBookingtimes = personBookingtimes.filter(bt => bt.people?.includes(person._id) ?? false);
            }

            if (personBookingtimes.length > 0) {
                bookingsMessage += personBooking.resource.name + "\n";
            }

            for (const bookingtime of personBookingtimes) {
                bookingsMessage += dateToText(new Date(bookingtime.start)) + " " + t("booking.guests.confirmationmessage.to") + " " + dateToText(new Date(bookingtime.end)) + "\n";
            }

            if (personBookingtimes.length > 0) {
                bookingsMessage += "\n";
            }
        }

        let emailMessage = settings?.confirmationTextEmail ?? "";

        if (emailMessage == undefined || emailMessage == "") {
            message += t("booking.guests.confirmationmessageemail.all");
        } else {
            message = emailMessage;

            message = message.replaceAll("[bookings]", bookingsMessage.slice(0, -2));
            message = message.replaceAll("[guest-firstname]", person.firstname);
            message = message.replaceAll("[guest-lastname]", person.lastname);
            message = message.replaceAll("[guest-organisation]", person.organization);
        }

        return message;
    }

    
    const handleShowEditGuestModal = (dataLine) => {
        setEditGuestId(dataLine["_id"]);
        setEditGuestOrg(dataLine["organization"]);
        setShowEditGuestModal(true);
    };


    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div style={{ marginTop: '20px' }}>
            <div className="Events-container">
                <h4 className="header-title">{t("events.title")}</h4>
                { auth.user["userdata"]["orgRole"][0] != "janitor" ?
                    <div>
                        <Button className="newpersonBtn" onClick={handleShowCreateGuestAndCustomerModal}>{t("booking.guests.add")}</Button>
                        <br/>
                        <br/>
                        <Button className="newpersonBtn" onClick={() => setShowCreateMultiplePersonsModal(true)}>{t("booking.guests.addmulti")}</Button>
                        <div className="messagebuttons" style={{
                            textAlign: "right"
                        }}>
                            <Button className="emailconfirmBtn" onClick={() => {
                                setShowConfirmationAllModal(true);
                            }}>{t("booking.guests.emailconfirm")}</Button>
                            <br/>
                            <br/>
                            <Button className="smsconfirmBtn" onClick={() => {
                                setShowConfirmationAllSmsModal(true);
                            }}>{t("booking.guests.smsconfirm")}</Button>
                        </div>
                    </div>
                : null}

                {id != undefined ?
                    <PageTable
                        dataUrl={"/api/bookings/getAllPaged/byEventId/" + id}
                        options={{
                            showFields: [
                                { label: t("bookings.bookingnumber"), field: "bookingnumber", override: (dataline) => dataline["bookingnumber"] != undefined ? dataline["bookingnumber"] : "" },
                                { label: t("bookings.organization"), field: "customerOrganization"},
                                { label: t("bookings.organizationnumber"), field: "companyRegistrationId", override: (dataline) => dataline["companyRegistrationId"] != undefined ? dataline["companyRegistrationId"] : ""},
                                { label: t("bookings.bookingguestscount"), field: "bookingguestscount", override: (dataline) => dataline["guests"].length != undefined ? dataline["guests"].length : ""},
                            ]
                        }}
                        onLineClick={(dataLine)=>{handleShowParticipantsModal(dataLine)}}
                        hidePagination={false}
                        hidePagesize={false}
                        hideFilter={false}
                        updateTable={updateTable}
                        hover={true}
                        permaFilters={[]}
                    />
                : null}
      
                <Modal show={showParticipantsModal}  size="xl" onHide={handleCloseParticipantsModal} >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("events.participants.title")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t("events.participants.info")}</p>
                        <PageTable
                            dataUrl={"/api/persons/getAllPaged/checkAll/bybooking/" + participantsEventId}
                            options={{
                                showFields: [
                                    { label: t("people.lastname"), field: "lastname" },
                                    { label: t("people.firstname"), field: "firstname" },
                                    { label: t("people.email"), field: "email" },
                                    { label: t("people.phone"), field: "phone" },
                                    { label: t("people.organization"), field: "organization" },
                                ]
                            }}
                            dataAfter={(dataLine) =>
                                auth.user["userdata"]["role"] == "Admin" ?
                                    <Button className="no-print" onClick={(evt) => handleGuestDeleted(dataLine, evt)}> {t("people.delete")} </Button>
                                : null
                            }
                            onLineClick={(dataLine)=>{ if (auth.user["userdata"]["orgRole"][0] != "janitor") handleShowEditGuestModal(dataLine) }}
                            hidePagination={false}
                            hidePagesize={false}
                            hideFilter={false}
                            updateTable={updateTable}
                            hover={auth.user["userdata"]["orgRole"][0] != "janitor"}
                            permaFilters={[]}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleCloseParticipantsModal}>
                            {t("events.close")}
                        </Button>
                    </Modal.Footer>
                </Modal>
                
                <CreateMultiplePersonsModal
                    show={showCreateMultiplePersonsModal}
                    event={props.event}
                    onCancel={() => setShowCreateMultiplePersonsModal(false)}
                    onHide={() => setShowCreateMultiplePersonsModal(false)}
                    onSaveNew={(createdPeople) => handleMultipleCustomersAndGuestsAdded(createdPeople)}
                    onBookingsChange={(changedBookings)=>{
                        if(props.onBookingsChange != undefined){
                            props.onBookingsChange(changedBookings)
                        }
                    }}
                    onCustomersChange={(changedCustomers)=>{
                        if(props.onCustomersChange != undefined){
                            props.onCustomersChange(changedCustomers)
                        }
                    }}
                ></CreateMultiplePersonsModal>
                <CreateGuestAndCustomerModal
                    event={props.event}
                    show={showCreateGuestAndCustomerModal}
                    people={props.people}
                    onCancel={() => setShowCreateGuestAndCustomerModal(false)}
                    onHide={() => setShowCreateGuestAndCustomerModal(false)}
                    onSelectExisting={(selectedPerson) => {
                        handleGuestAdded(selectedPerson);
                        setUpdateTable(updateTable + 1); 
                    }}
                    onSaveNew={(createdPerson) => {
                        handleGuestAdded(createdPerson);
                        setUpdateTable(updateTable + 1); 
                    }}
                    onBookingsChange={(changedBookings)=>{
                        if(props.onBookingsChange != undefined){
                            props.onBookingsChange(changedBookings)
                        }
                    }}
                    onCustomersChange={(changedCustomers)=>{
                        if(props.onCustomersChange != undefined){
                            props.onCustomersChange(changedCustomers)
                        }
                    }}
                    customers={props.customers}
                ></CreateGuestAndCustomerModal>
                <EditPersonModal
                    show={showEditGuestModal}
                    personId={editGuestId}
                    org={editGuestOrg}
                    onCancel={() => setShowEditGuestModal(false)}
                    onHide={() => setShowEditGuestModal(false)}
                    onSaveEdit={() => {
                        setShowEditGuestModal(false);
                        setUpdateTable(updateTable + 1);
                    }}
                ></EditPersonModal>
                <SMSSender
                    show={showConfirmationAllSmsModal}
                    onHide={() => setShowConfirmationAllSmsModal(false)}
                    onCancel={() => setShowConfirmationAllSmsModal(false)}
                    customMessages={true}
                    recipients={allGuests.map(i => {
                        return {
                            number: i.phone,
                            name: i.lastname + ", " + i.firstname,
                            message: generateConfirmationMessageSms(i)
                        }
                    })}
                ></SMSSender>
                <EmailSender
                    show={showConfirmationAllModal}
                    onHide={() => setShowConfirmationAllModal(false)}
                    onCancel={() => setShowConfirmationAllModal(false)}
                    customMessages={true}
                    attachMapImage={true}
                    recipients={allGuests.map(i => {
                        return {
                            email: i.email,
                            name: i.lastname + ", " + i.firstname,
                            subject: "",
                            message: generateConfirmationMessageEmail(i)
                        }
                    })}
                ></EmailSender>
            </div>
         </div>
    );
}


export default EventGuests;